import React from 'react';
import { getImageSrc, getLabelsByLanguage } from "../../../utilites/util";
import useOutsideClick from '../../../hooks/useOutsideClick';
import forward from '../../assets/images/arrows/forward-arrow.png';
import WishListIconContainer from "../../components/wishList/wishListIcon/WishListIconContainer";
import SendToTnAccountContainer from "../../../auth/SendToTnAccount";
import LogoutFromTnAccountContainer from "../../../auth/LogoutFromTnAccount";
import classNames from "classnames";
import Validator from '../../../validators/Validator';
import { useSelector } from 'react-redux';
import { AppState } from '../../../app/store/rootReducers';
import HeaderProfilePopup from "../../components/headerProfilePopup";
import "./item.scss";

const labels = getLabelsByLanguage();
const spanRef = React.createRef<HTMLSpanElement>();
const detailsRef = React.createRef<HTMLDetailsElement>();
const activeClassName = 'active';

type ItemObject = {
  id: string;
  title: string;
  url: string;
  cssClass: string;
  img: {
    title: string;
  }
  items: [];
  identifier?: string;
  redirectTo: string;
};

type ActiveItem = {
  id: number
};

interface Props {
  item: ItemObject;
  activeItem?: ActiveItem;
  cssClasses: string;
  isLogin: boolean;
  isRenderImgForward?: boolean;
  isDesktop?: boolean;
  handleOnClick?: (item: object, isLogin: boolean) => void;
}

const Item: React.FC<Props> = ({
  item,
  activeItem,
  cssClasses,
  isLogin,
  isRenderImgForward,
  isDesktop,
  handleOnClick,
}) => {
  useOutsideClick(detailsRef);

  const cartNumber = useSelector((state: AppState) => state.session.numberOfOrderItems);

  const checkIsActive = (itemId: string): boolean => {
    return Boolean(activeItem) && (activeItem as ActiveItem).id.toString() === itemId;
  };

  const onClick = () => {
    if (isDesktop) {
      const isActive = spanRef.current?.classList.contains(activeClassName);

      document.querySelectorAll(`#menu .${activeClassName}`)
        .forEach((el) => el.classList.remove(activeClassName));

      if (!isActive) {
        (spanRef.current as HTMLElement)?.classList.add(activeClassName);
      }
    }

    if (handleOnClick) {
      handleOnClick(item, isLogin);
    }
  };

  if (item.identifier === 'login') {
    return (
      <div className="account-login">
        <SendToTnAccountContainer from={window.location.href} isTextVisible={true}/>
      </div>
    );
  }

  if (item.title === labels.logout) {
    return (
      <div className="responsive-link">
        <LogoutFromTnAccountContainer>
          <span id="2" className={`list-item third-level no-child undefined`}>{labels.logout}</span>
        </LogoutFromTnAccountContainer>
      </div>
    );
  }

  if (item.title === 'Wishlist') {
    return (
      <span className="d-block me-2 pe-1 pt-1 p-0" key={item.id}>
        <WishListIconContainer/>
      </span>
    );
  }

  if (item.title.match(/cart/)) {
    return (
      <a
        key={item.id}
        {...(item.items.length ? { href: '#' } : { href: item.url })}
        target="_blank"
      >
        <span
          ref={spanRef}
          id={item.id}
          onClick={onClick}
          className={classNames(
            !(typeof item.items !== 'undefined' && item.items.length) && 'no-child',
            item.cssClass,
            Boolean(cartNumber) && 'p-0'
          )}>
          {
            Boolean(Object.keys(item.img).length) && (
              <img className="icon" alt={item.img.title} src={getImageSrc("", item.img.title, 'png')}/>
            )
          }
          {Boolean(cartNumber) && (
            <span className="cart-icon-number p-1 px-2">
              {cartNumber}
            </span>
          )}
        </span>
      </a>
    );
  }

  if (item.title === 'yettel-ecosystem') {
    return (
      <>
        <div style={{ visibility: 'hidden', width: '0' }}>
          <SendToTnAccountContainer from={window.location.href} isTextVisible={true}/>
        </div>
        <div className="yettel-ecosystem-menu me-2">
          <details ref={detailsRef} data-popover="down">
            <summary className="d-block pe-1 pt-1 p-0" key={item.id}>
              <div className="ytl-icon-container"></div>
              <img className="icon" alt={item.img.title} src={getImageSrc("", item.img.title, 'png')} />
            </summary>
            <div className="ytl-popover-menu-list">
              {item.items.map((item: any) => {
                return (
                  <a href={item.url} className="ytl-menu-item" key={item.url}>
                    <img className="ytl-menu-item-icon" alt={item.img.title} src={getImageSrc("", item.img.title, 'png')} />
                    <div className="ytl-menu-item-text">
                      <p>{item.title}</p>
                    </div>
                  </a>
                );
              })}
            </div>
          </details>
        </div>
      </>
    );
  }

  if (item.identifier === 'loggedIn') {
    return <HeaderProfilePopup item={item} hideSubmenu={() => {}} />;
  }

  return (
    <a
      key={item.id}
      {...(item?.items?.length ? null : { href: item.redirectTo !== '' ? item.redirectTo : item.url })}
    >
      <span
        ref={spanRef}
        id={item.id}
        onClick={onClick}
        className={classNames(
          cssClasses,
          checkIsActive(item.id.toString()) && activeClassName,
          !Validator.checkIfArrayHasItems(item.items) && 'no-child',
          item.cssClass,
          Boolean(item.img && Object.keys(item.img).length) && "ytl-mobile-menu-item yettel-font"
        )}
      >
        {
          Boolean(item.img && Object.keys(item.img).length) && (
            <img className="icon me-3" alt={item.img.title} src={getImageSrc("", item.img.title, 'png')}/>
          )
        }
        {item.title}
        {isRenderImgForward && <img alt="forward" src={forward}/>}
        {
          Boolean(item.img && Object.keys(item.img).length && !isDesktop) && (
            <img className='ytl-menu-item-arrow' alt="forward" src={forward}/>
          )
        }
      </span>
    </a>
  );
};

export default Item;
